<template>
<div id="contentWrap">
    <div class="content left">
        <div id="content_1block" class="left">
            <div class="response">
                <div class="resendmail linkfont"><span style="color: #009A21;">Link for password reset has been sent to <a href="javascript: void(0)">{{email}}</a></span>
                    <p>If you haven’t received the email , please click <a href="javascript: void(0)" @click="ResendMail()">here</a> to resend.</p>
                </div>
            </div>
            <div style="width: 200px; margin-left: auto; margin-right: auto;">
                <button class="button-warning pure-button" @click="back()">Back to Home</button>
            </div>
        </div>
        <modal v-if="showModal" @close="showModal = false" />
    </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import router from '../../router.js';
import Modal from '../../tools/Modal';
export default {
    components: {
        Modal
    },
    data: function() {
        return {
            email: '',
            showModal: false
        };
    },
    methods: {
        ResendMail: function() {
            var url = sessionStorage.getItem('forgetpswLink');
            this.showModal = true;
            this.$http.get(url).then((response) => {
                // success callback
                var datums = response.data;
                if (datums > 0) {
                    this.showModal = false;
                } else {

                }
            }, (response) => {
                // error callback
            });
        },
        back: function() {
            router.push('/');
        }
    },
    mounted() {
        this.email = sessionStorage.getItem('forgetpswEmail');
    }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// ResendMail.vue?75ef8a26